import AuthKit from "./AuthKit";

export default class {
  constructor() {
    this.authKit = new AuthKit();
    this.url = "/announcements/"
    this.LOCAL_STORAGE_KEY = "MESSAGE_IDS"
  }

  async getMessageList(event_slug) {
    const url = `${this.url}messages/${event_slug}/`;
    const response = await this.authKit.doGet(url);
    return response.data;
  }

  async createPrivateRoom(event_slug, usersArray, description) {
    const url = `${this.url}messages/${event_slug}/private-meeting/`;
    const payload = {
      event_users: usersArray,
      description: description
    }
    const response = await this.authKit.doPost(url, payload);
    return response.data;
  }

  async agentInviteMessage({
    eventUserIds = [],
    description = '',
    pageSlug = ''
  }) {
    const url = `${this.url}messages/agents/event-users/invite/`
    // const payload = {...urlParams}
    const payload = {
      eventUserIds,
      pageSlug,
      description
    }
    const response = await this.authKit.doPost(url, payload)
    return response.data
  }

  setMessageItemIdToLocalStorage(id) {
    let items = this.getMessageItemIdsFromStorage()
    items = { ...items, [id]: true }
    localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(items))
  }

  getMessageItemIdsFromStorage() {
    const localStorageItem = localStorage.getItem(this.LOCAL_STORAGE_KEY)
    return JSON.parse(localStorageItem) || {}
  }

  hasSeenMessageId(id) {
    const messageIds = this.getMessageItemIdsFromStorage()
    if (messageIds) {
      return messageIds[id]
    }
    return false
  }
}
